const Breakpoints = {
  small: 888,
}

export default Breakpoints
